import { Component, OnInit } from "@angular/core";

import { GlobalsService } from "./globals.service";

@Component({
  selector: "app-debug",
  templateUrl: "./debug.component.html",
  styleUrls: ["./debug.component.css"],
})
export class DebugComponent implements OnInit {
  public constructor(public globalsService: GlobalsService) {}

  public ngOnInit() {}
}
